// 分类数据
export const CATE_DATA = [
    {
        'id': 1,
        'title': '签到设置'
    },
    {
        'id': 2,
        'title': '查券设置'
    },
    {
        'id': 3,
        'title': '视频设置'
    },
    {
        'id': 4,
        'title': '订单设置'
    },
    {
        'id': 5,
        'title': '推广设置'
    },
    {
        'id': 6,
        'title': '账户设置'
    },
    {
        'id': 7,
        'title': '导购设置'
    },
    {
        'id': 8,
        'title': '订单付款消息'
    },
    {
        'id': 9,
        'title': '订单结算消息'
    },
    {
        'id': 10,
        'title': '已结算退款消息'
    },
    {
        'id': 11,
        'title': '未结算退款消息'
    }
]

export const list = [
    {
        id: 1,
        name: '签到成功提示',
        nouns: '商品标题,商品价格,淘口令',
        cate: 1,
        content: `@[昵称]

    您已签到成功，本次奖励[获得余额]元，当前余额[总余额]元。
    每天都签到，每天的奖励都可能不同哦，记得明天也来试试你的手气。
    发送“帮助”，可了解更多操作[微笑]
    [玫瑰][玫瑰][玫瑰][玫瑰][玫瑰][玫瑰][玫瑰]
     Have a nice day！
`
    },
    {
        id: 2,
        name: '重复签到提示',
        nouns: '商品标题',
        cate: 1,
        content: `
@[昵称]



    亲，您今天已经签过喽，一天只能一次，明天再来吧

    [酷][酷][酷]`
    },
    {
        id: 3,
        name: '无订单签到提示',
        nouns: '',
        cate: 1,
        content: `@[昵称]



    因为您还无订单，所以，暂时无法签到，赶紧去查询自己喜欢的宝贝吧，有订单之后，可以一直签到，领取奖励哦；

    发送“帮助”，可了解更多操作[微笑]`
    }
]